import { clearAidaComposerDraft } from './composer-session'
import { clearAidaConversationSession } from './conversation-session'
import { clearAidaOverlaySession } from './overlay-session'
import { resetAidaOverlay } from './overlay-store'
import { resetAidaPictureInPicture } from './picture-in-picture-store'
import { bumpAidaSessionEpoch } from './session-epoch'

export function clearAidaPersistedSession() {
  clearAidaConversationSession()
  clearAidaComposerDraft()
  resetAidaOverlay()
  clearAidaOverlaySession()
  resetAidaPictureInPicture()
  bumpAidaSessionEpoch()
}
